import React, { Component } from "react";
// import QuestionRow from "../../questionRow";
// import AnswerLine from "../../answers/answer_line";

import ListQuestion from "../../list/interface/list_question";
import ListAnswerRow from "../../list/interface/list_answer_row";

class UserQuestionAnswer extends Component {
  state = { removed: false };
  render() {
    if (this.state.removed) {
      return <div />;
    }
    return (
      <div className="pb-5">
        <div className="question_answer_v2">
          <ListQuestion
            question={this.props.answer.question}
            showAnswer={true}
            onClick={this.openQuestion}
            row={this.state.row}
            link={true}
          />
        </div>
        <ListAnswerRow
          answer={this.props.answer}
          row={true}
          removeAnswer={this.removedView}
          updateAnswer={this.props.updateAnswer}
        />
        {/* <QuestionRow question={this.props.answer.question} showAnswer={true} /> */}
        {/* <AnswerLine
          answer={this.props.answer}
          profileView={true}
          removedView={this.removedView}
        /> */}
      </div>
    );
  }
  removedView = event => {
    this.setState({ removed: true });
  };
}

export default UserQuestionAnswer;



// WEBPACK FOOTER //
// ./src/components/profile/user_data/user_question_answer.jsx